module.exports = "https://static.wmbcdn.com/uniweb/images/ca24b40f9b2b2d390c0327b14441c980.svg";